<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
  <div class="mb-8">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 mb-2">Work Breakdown Structure</h1>
        <p class="text-gray-600">Select a project to create or manage its WBS activities</p>
      </div>
    </div>
  </div>

  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <div class="flex flex-col sm:flex-row gap-4">
        <div class="relative flex-1">
          <input
            type="text"
            placeholder="Search projects..."
            (input)="applyFilter($event)"
            class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto" *ngIf="!loading">
      <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">#</th>
          <td mat-cell *matCellDef="let element; let i = index" class="px-6 py-4">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="projectName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4">Project Name</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4 font-medium">{{ element.project_name || element.projectName || 'N/A' }}</td>
        </ng-container>

        <ng-container matColumnDef="projectIdentifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4">Project ID</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4 text-gray-600">{{ element.project_identifier || element.projectIdentifier || element.id || 'N/A' }}</td>
        </ng-container>

        <ng-container matColumnDef="stage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4">Stage</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">
            <span class="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
              {{ element.stage || 'Not Set' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4">Start Date</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">{{ (element.start_date || element.startDate) | date:'mediumDate' }}</td>
        </ng-container>

        <ng-container matColumnDef="endDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4">End Date</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">{{ (element.end_date || element.endDate) | date:'mediumDate' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="px-6 py-4">Actions</th>
          <td mat-cell *matCellDef="let element" class="px-6 py-4">
            <button
              (click)="openWBS(element)"
              class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
            >
              <mat-icon class="mr-1 !text-lg !w-5 !h-5">edit_note</mat-icon>
              Create / Edit WBS
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hover:bg-gray-50"></tr>
      </table>
    </div>

    <div *ngIf="loading" class="p-8 text-center">
      <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto"></div>
      <p class="mt-2 text-gray-600">Loading projects...</p>
    </div>

    <div *ngIf="!loading && dataSource.data.length === 0" class="text-center py-12">
      <mat-icon class="text-gray-400 text-6xl mb-4">folder_open</mat-icon>
      <h3 class="text-lg font-medium text-gray-900 mb-2">No projects found</h3>
      <p class="text-gray-500">Create a project first to add Work Breakdown Structure.</p>
    </div>

    <div *ngIf="!loading && dataSource.data.length > 0" class="px-6 py-4 border-t border-gray-200">
      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
